import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useHistory, matchPath } from 'react-router-dom';
import _ from 'lodash';

import './ContentBlock.scss';
import useCheckProduct from '../../hooks/useCheckProduct';
import useCheckDatetime from '../../hooks/useCheckDatetime';
import useCheckContentVisibility from '../../hooks/useCheckContentVisibility';

interface ContentBlockProps {
  data?: {
    contentBlocks: [
      { body: string, title: string, showOptions }
    ],
    blocks?: [
      { body: string, title: string, showOptions }
    ]
  },
  preview?: boolean
}

export default function ContentBlock({ data, preview }: ContentBlockProps) {
  const contentBlocks = preview ? data.blocks[0] : data.contentBlocks[0];
  const history = useHistory();
  const checkProduct = useCheckProduct(contentBlocks);
  const checkDatetime = useCheckDatetime(contentBlocks);
  const checkVisibility = useCheckContentVisibility(contentBlocks);
  if (_.isEmpty(contentBlocks)) return null;
  const matchPage = matchPath(history.location.pathname, {
    path: ['/lotto', '/sports-betting/:type', '/racing/:type'],
    exact: true,
    strict: true
  });

  if (matchPage || preview && (checkProduct && checkDatetime && checkVisibility)) {
    return (
      <div className="content-block">
        <h3 className="content-block__title">{ contentBlocks.title }</h3>
        <div className="content-block__body">
          { ReactHtmlParser(contentBlocks.body) }
        </div>
      </div>
    );
  }

  return null;
}
